import React from 'react';
import { Loader } from 'ui-library';

export const Loading = () => <Loader light />;
